import { useRef, useState, useEffect } from 'react';
import { Grid, Button, Box } from '@mui/material';
import change from '@shared/assets/change.svg';

import { getAirports } from '@shared/services/services';

import AirportAutoComplete from './AirportAutoComplete';

import { sxStyle } from './styles';

let cachedAirports = null;

const FromToAutocomplete = ({
  origin,
  destination,
  flightOrigin,
  flightDestination,
  sectionNumber,
}) => {
  const skipOpenRef = useRef(false);
  const [airports, setAirports] = useState([]);

  const handleSwap = () => {
    skipOpenRef.current = true;
    flightOrigin(destination);
    flightDestination(origin);
    setTimeout(() => {
      skipOpenRef.current = false;
    }, 1);
  };

  const loadAirports = async () => {
    if (cachedAirports) {
      setAirports(cachedAirports);
      return;
    }

    try {
      const result = await getAirports();
      cachedAirports = result;
      setAirports(result);
    } catch (error) {
      console.error('Error fetching airports:', error);
    }
  };

  useEffect(() => {
    loadAirports();
  }, []);

  return (
    <Grid
      container
      id="airport-autocomplete-grid"
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          md: '1fr auto 1fr',
        },
        alignItems: 'center',
        gap: { xs: 2, md: 0 },
      }}
    >
      {/* Origen */}
      <Grid item id="airport-origin">
        <AirportAutoComplete
          placeHolder="Origen"
          value={origin}
          onChange={flightOrigin}
          skipOpenRef={skipOpenRef}
          id="airport-origin-input"
          airports={airports}
          sectionNumber={sectionNumber}
        />
      </Grid>

      {/* Botón intermedio */}
      {
        <Grid
          item
          id="swap-button-container"
          sx={{ display: { xs: 'none', md: 'flex' } }}
        >
          <Button
            id="swap-button"
            tabIndex={-1}
            disableRipple
            sx={sxStyle.planeButton}
            onClick={handleSwap}
          >
            <Box
              component="img"
              src={change}
              alt="change"
              id="swap-button-icon"
              sx={sxStyle.planeIcon}
            />
          </Button>
        </Grid>
      }

      {/* Destino */}
      <Grid item id="airport-destination">
        <AirportAutoComplete
          placeHolder="Destino"
          value={destination}
          onChange={flightDestination}
          skipOpenRef={skipOpenRef}
          id="airport-destination-input"
          airports={airports}
          sectionNumber={sectionNumber}
        />
      </Grid>
    </Grid>
  );
};

export default FromToAutocomplete;
